export default "__VITE_ASSET__C4R4Tu9J__"